// being used in src/shared/components/BriefingPageHeader/BriefingPageHeader.js and src/shared/components/SubHeader/SubHeader.tsx
// migrated to src_new/ui/core/page/Header/PageHeader.tsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Text } from '@xingternal/winery-ui/lib/Text';

const PageHeaderWrapper = styled.div`
  align-items: center;
  justify-content: space-between;
  background-color: ${themeGet('colors.cardBackground')};
  display: flex;
  padding: ${themeGet('space.4')};
`;

const PageTitle = styled(Text).attrs({ size: 5 })`
  margin-bottom: ${(props) => (props.hasDescription ? themeGet('space.2') : 0)};
`;

const PageDescription = styled(Text).attrs({
  size: 1,
  color: 'secondaryText',
})``;

const PageHeader = ({ title, children, description }) => (
  <PageHeaderWrapper>
    <PageTitle hasDescription={description}>{title}</PageTitle>
    {description && <PageDescription>{description}</PageDescription>}
    {children}
  </PageHeaderWrapper>
);

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export { PageHeader };
